import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6993fe9bf782d50014390729_1788188447280_fc08e0e3/eastcoastunderground/src/app/services/energy/page.tsx");
